import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((theme: Theme) => ({
    stickyFooter: {
        position: "sticky",
        bottom: 0,
        zIndex: 3,
        display: "flex",
        justifyContent: "flex-start",
        backgroundColor: theme.palette.emteria.background.paper,
        padding: theme.spacing(5),
        width: "100%",
    },
    footerRightContainer: {
        display: "flex",
        marginLeft: "auto",
        gap: theme.spacing(1),
    },
    dialogContent: {
        width: 400,
        padding: theme.spacing(2),
    },
    form: {
        width: "100%",
        height: "100%",
        display: "relative",
    },
}));
